import {
  selectCodiceProgramma,
  selectNumeroAvvenimento,
  selectScommesseListByScommessaKey,
} from 'features/ippica/selectors';

import { IppicaScommesseTableRowPariDispari } from '../../ippicaScommesseTableRow/IppicaScomesseTableRowPariDispari';
import { IppicaScommesseTableTitles } from '../../ippicaScommesseTableTitles';
import styles from '../IppicaScommesseRenderer.module.scss';
import { useTypedSelector } from 'lib/centralStore';

export type IppicaScommesseRendererPariDispariProps = {
  isMobile: boolean;
  tipoScommessaKey: 119 | 120;
};

export const IppicaScommesseRendererPariDispari = ({
  isMobile,
  tipoScommessaKey,
}: IppicaScommesseRendererPariDispariProps) => {
  const codiceProgramma = useTypedSelector(selectCodiceProgramma);
  const numeroAvvenimento = useTypedSelector(selectNumeroAvvenimento);
  const scommesseListByScommessaKey = useTypedSelector(
    selectScommesseListByScommessaKey(`${codiceProgramma}_${numeroAvvenimento}_${tipoScommessaKey}`)
  );
  let keyQuotaList: string[] | undefined = [];

  if (scommesseListByScommessaKey) {
    keyQuotaList = scommesseListByScommessaKey[0].esitoKeyList;
  }
  return (
    <>
      {!isMobile && (
        <IppicaScommesseTableTitles
          titles={[{ label: 'Pari/Dispari' }]}
          containerClassName={styles.tableTitlesCentered}
        />
      )}

      <IppicaScommesseTableRowPariDispari quote={keyQuotaList} />
    </>
  );
};
